import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 5px;
`;

export const WrapperInputCustom = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

export const Column = styled.div`
  flex: 1;
`;

export const FieldLabel = styled.text`
  font-size: 12px;
  color: #7b7b7b;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 6px;
`;

export const Error = styled.span`
  padding: 5px;
  font-size: 12px;
  color: #F27160;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  align-self: center;
  margin-top: 5px;
`;
